
import Vue from 'vue'
import { VCardActions, VCardText, VForm, VSpacer } from 'vuetify/lib'
import JcdcAlert from '@/components/jcdc/JcdcAlert.vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import JcdcCheckbox from '@/components/jcdc/JcdcCheckbox.vue'
import JcdcModal from '@/components/jcdc/JcdcModal.vue'
import JcdcTextField from '@/components/jcdc/JcdcTextField.vue'

export default Vue.extend({
  name: 'JcdcModalCard',
  components: {
    VCardActions,
    VCardText,
    VForm,
    VSpacer,
    JcdcAlert,
    JcdcBtn,
    JcdcCheckbox,
    JcdcModal,
    JcdcTextField,
  },
  props: {
    formError: { type: Boolean, default: false },
    bllError: { type: String, default: 'Invalid username and/or password.' },
    timeoutError: { type: Boolean, default: false },
  },
  data() {
    return {
      checked: false,
      showPW: false,
      valid: false,
      dialog: false,
    }
  },
  computed: {
    iconChange(): string {
      return this.showPW ? 'mdi-eye' : 'mdi-eye-off'
    },
    typeChange(): string {
      return this.showPW ? 'text' : 'password'
    },
  },
  methods: {
    agreeClick() {
      this.checked = true
      this.dialog = false
    },
    validate() {
      this.dialog = !this.checked
      ;(this.$refs.form as Vue & { validate: () => boolean }).validate()
      if (this.valid) {
        this.$emit('login-click', this.valid)
      }
    },
  },
})
